module.exports = __webpack_public_path__ + "statics/img/5G.a9b4662e.jpg";